import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EmailService } from '../../service/email.service';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrl: './email-template.component.scss',
    standalone: false
})
export class EmailTemplateComponent implements OnInit {
  userId: number = 0;
  role: string = '';
  templates: any[] = [];
  filteredItems: any;
  showNoCardsMessage: boolean;
  constructor(public router: Router,private emailservice:EmailService,private dialog: MatDialog, private toastr: ToastrService,) {
    this.filteredItems = this.templates;
   }
  ngOnInit(): void {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.role = sessionStorage.getItem('role');
    this.getEmail();
     
  }
  CreateTemp(){
    this.router.navigate(['/app-create-template'], { skipLocationChange: true});
  }
  updateTemplate(id) {
    this.router.navigate(['/app-create-template',id], { skipLocationChange: true });
  }
  delete(Id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: {message: 'Are you sure you want to delete?'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.emailservice.deleteEmail(Id).subscribe(data => {
          const message = data.status;
          if (message == "deleted successfully") {
            this.toastr.success('Deleted Successfully.', '', { positionClass: 'toast-top-right' });
          } else {
            this.toastr.info(message, '', { positionClass: 'toast-top-right' });
          }
          this.getEmail();
        });
      }
    });
  }
  // loadData(loginId: number): void {
  //   this.subscription = this.emailservice.getTemplateList(loginId).subscribe({
  //     next: (response) => {
  //       if (response.templateInfo && response.templateInfo.length > 0) {
  //         this.totalTemplateCount = response.templateInfo.length;
  
  //         this.items = response.templateInfo.map((item) => {
  //           return {
  //             id: item.id,
  //             template_name: item.template_name,
  //             subject: item.subject,
  //             is_enabled: item.is_enabled === 'true' // Convert string to boolean if necessary
  //           };
  //         });
  //       } else {
  //         this.items = []; // Handle case where no templates are returned
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching template data', error);
  //     }
  //   });
  // }
  

   applyFilter(value: string) {
    const filterValue = value.toLowerCase().trim();
    this.filteredItems = this.templates.filter(item =>
      (item.template_name && item.template_name.toLowerCase().includes(filterValue)) ||
      (item.objectives && item.objectives[0] && item.objectives[0].toLowerCase().includes(filterValue)) ||
      (item.desc && item.desc.toLowerCase().includes(filterValue))
    );
    
    this.showNoCardsMessage = this.filteredItems.length === 0;
  }
  getEmail() {
    this.emailservice.getemailList().subscribe(data => {
      this.templates = data.templateInfo;
      this.filteredItems = this.templates; 
    }, error => {
      console.error('Error fetching email templates:', error);
    });
  }

}